<template>
  <div class="columns is-mobile">
    <span class="column">
    <span v-for="(segment, index) in segments">
      <b-icon size="is-small" :icon=iconsMap[segment]></b-icon>
      <!--only show the right arrow if it isn't the last segment-->
      <span v-if="index !== segments.length - 1">&nbsp;&rarr;&nbsp;</span>
        </span>
  </span>
    <!--<span class="column time">{{arriveTime}}</span>-->
  </div>
</template>

<script>
  export default {
    name: 'IconSegments',
    props: ['permutation', 'departTime', 'arriveTime'],
    data() {
      return {
        segments: this.permutation.split(':'),
        iconsMap: {
          'ride-share': 'uber',
          'drive': 'car',
          'bus': 'bus',
          'flight': 'airplane'
        }
      };
    },
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .time {
    font-size: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/IconSegments.vue